<div class="column-mapping" *ngIf="!loading && service.columnData && service.project && !service.errorMessage"
     (click)="columnMappingClick($event)">
    <h4>Database Field Mapping:</h4>
    <button class="icon inline btn btn-transparent" title="Help" (click)="showHelp = !showHelp">
        <span class="icon icon-ui-question"></span>
    </button>
    <div class="help field-mapping" *ngIf="showHelp">
        <button class="icon inline close" (click)="showHelp = !showHelp">
            <span class="icon icon-ui-close"></span>
        </button>
        <p>
            This program automatically maps or matches the database field names with the columns in your
            imported spreadsheet.
            This automatic matching is done based on header names. The automatic matching is not always correct,
            especially if the spreadsheet headers are cryptic or missing.
            You have a chance here to manually correct and modify the field mappings.
        </p>
        <p>
            To map database fields to a spreadsheet column, simply drag the appropriate field from the unused
            database list and drop it onto the appropriate column header.
        </p>
        <p>
            To remove a mapped field from a column, drag the field from the column header and drop it onto
            another field header or a field name in the unused list.
        </p>
        <p>When dropping fields, be sure to move your mouse pointer into the box.</p>
        <p>
            When finished, click <strong>Validate and Submit to Stage.</strong> This button is only available
            when you have entered a valid project name and have mapped enought fields to create points or lines.
        </p>
        <h4>Field Constraints</h4>
        <p>
            For fields that have a fixed size like County or SR, the application pads values with zeros. Below
            are the field sizes if applicable.
        </p>
        <table class="table standard-fields">
            <thead>
                <tr>
                    <th>Field Name</th>
                    <th>Size</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let standardField of standardFields">
                    <tr>
                        <td class="field-name">{{ standardField.displayName }}</td>
                        <td>{{ standardField.maxLength ? standardField.maxLength : 'Numeric' }}</td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <p>Char fields Have a Max Length of 100</p>
        <p>Numeric fields Can Have up to 38 significant digits</p>
        <p>Date fields should be formatted: MM/DD/YYYY</p>
    </div>
    <div class="input-button-container">
        <div class="start-sheet-start-row-geometry-type">
            <div class="start-sheet" *ngIf="service.sheetCount > 1">
                <label>Sheet:</label>
                <select class="form-control" id="sheetNumber" name="sheetNumber" [(ngModel)]="service.sheetNumber"
                        style="width: auto; display: inline-block;" (change)="service.resetAutomatedColumnMapping()">
                    <option [ngValue]="sheet" *ngFor="let sheet of sheetsForSelect"> {{ sheet }} </option>
                </select>
            </div>
            <div class="start-row">
                <label>Start Row:</label>
                <input type="number" class="form-control" id="startRow" name="startRow" min="1" max="10"
                       (change)="redefineStartingRowNumber();" [(ngModel)]="service.startingRowNumber">
            </div>
            <div class="geometry-type">
                <label>Geometry:</label>
                <span class="label geometry-type" class="{{ geometryClass }}">{{ geometryType }}</span>
            </div>
        </div>
        <div class="button-group">
            <button type="button" class="btn red" (click)="removeAllMappings();" [disabled]="noColumnsMapped">
                <span class="icon icon-ui-close"></span>
                Remove All Mappings
            </button>

            <button type="button" class="btn btn-xs red" (click)="clearPreviousMappingAndResetColumnMapping();"
                    [disabled]="!service.resultContainedPreviousMapping && !service.mappingsFromServerAltered">
                <span class="icon icon-ui-refresh"></span>
                Reset Mappings
            </button>

            <button type="button" class="btn btn-xs btn-primary automap-custom-fields" (click)="automapCustomFields()"
                    [disabled]="allColumnsMapped">
                <span class="icon icon-ui-plus-circled"></span>
                Map Custom Fields
            </button>
        </div>
    </div>
    <div class="unused-fields">
        <ng-container *ngFor="let databaseField of databaseFieldsNotCustom">
            <div class="database-field-container" draggable="true" (dragover)="dragOver($event)" (drop)="unusedDrop()"
                 (dragstart)="unusedDragStart(databaseField)" (dragend)="dragEnd()">
                <div title="{{ databaseField.databaseName }}" class="unused alert alert-success">
                    {{ databaseField.displayName }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngFor="let databaseField of databaseFieldsCustom">
            <div class="database-field-container" draggable="true" (dragover)="dragOver($event)" (drop)="unusedDrop()"
                 (dragstart)="unusedDragStart(databaseField)" (dragend)="dragEnd()">
                <div title="{{ databaseField.databaseName }}" class="unused alert alert-info">
                    {{ databaseField.displayName }}
                </div>
            </div>
        </ng-container>
        <div class="preserved-column-mapping" role="alert"
             *ngIf="(service.showRepeatFileHeaderIndicator || service.showRepeatFileNameIndicator) && !service.mappingsFromServerAltered">
            <strong>
                Your column mapping settings have retrieved from the last time you validated a file with
                these file headers.
            </strong>
            <button type="button" class="close icon" (click)="service.showRepeatFileNameIndicator = false;">
                <span class="icon icon-ui-close"></span>
            </button>
        </div>
    </div>
    <div class="mapped-fields">

        <div class="table-responsive">
            <table class="table table-striped data-file-sample" *ngIf="fileType !== 'xls' && fileType !== 'xlsx'">
                <thead>
                    <tr>
                        <ng-container *ngFor="let dataitem of service.columnData">
                            <th [ngClass]="{hover: hover}" (mouseenter)="hover = true" (mouseleave)="hover = false">
                                <div class="remove-field"
                                     [ngClass]="{'database-field-assigned': dataitem.databaseField}">
                                    <button *ngIf="dataitem.databaseField" (click)="removeMappedField(dataitem)"
                                            class="btn btn-xs red remove">
                                        <span class="icon icon-ui-trash"></span>
                                    </button>
                                </div>
                                <div title="{{ dataitem.databaseField ? dataitem.databaseField.databaseName : '' }}"
                                     class=" column-element" [class.empty]="!dataitem.databaseField"
                                     [class.matched]="dataitem.databaseField && !dataitem.dragOver && !dataitem.dragOverCustom"
                                     [class.custom]="dataitem.databaseField && dataitem.databaseField.customField && !dataitem.dragOver && !dataitem.dragOverCustom"
                                     [class.drag-over]="dataitem.dragOver"
                                     [class.drag-over-custom]="dataitem.dragOverCustom" draggable="true"
                                     (dragover)="dragOver($event, dataitem)" (drop)="drop(dataitem)"
                                     (dragstart)="dragStart(dataitem)" (dragEnd)="dragEnd()"
                                     (dragleave)="dragLeave(dataitem)" (click)="dataItemClick($event, dataitem)">
                                    <span class="drag-element">
                                        <span class="display-name" *ngIf="!dataitem.editMode">
                                            {{ dataitem.displayName }}
                                        </span>
                                        <span class="display-name-input"
                                              *ngIf="dataitem.databaseField && dataitem.editMode" title="{{ dataitem.databaseField ? dataitem.databaseField.databaseName : '' }}">
                                            <input type="text" class="edit-alias" (blur)="inputBlur($event, dataitem)"
                                                   value="{{ dataitem.databaseField ? dataitem.databaseField.aliasName : ''}}"
                                                   [(ngModel)]="dataitem.databaseField.aliasName" />
                                        </span>
                                    </span>
                                </div>
                                <div class="petl-header" id="{{ dataitem.id }}">
                                    {{ dataitem.nativeHeader }}
                                </div>
                            </th>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let val of service.fileSample">
                        <td align="center" *ngFor="let d of val">
                            {{ d }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
